var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showComponent)?_c('RetailerSelectionComponent',{attrs:{"label":_vm.label,"hideLabel":_vm.hideLabel,"retailerLimit":_vm.retailerLimit,"allowedManufacturerIds":_vm.allowedTestDriveManufacturerIds,"blockedRangeIds":_vm.blockedRangeIds,"validationScope":_vm.validationScope}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }